import { __makeTemplateObject } from "tslib";
import { css, palette2, px } from '../../../../foundation';
import { RcTableBody } from '../../TableBody';
import { RcTableCell } from '../../TableCell';
import { RcTableRow } from '../../TableRow';
export var TableContainerStyle = function (props) {
    var bordered = props.bordered, square = props.square;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ",
        "\n  "])), bordered && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: ", ";\n      border: 1px solid ", ";\n\n      ", " ", ":last-child ", " {\n        border: none;\n      }\n    "], ["\n      border-radius: ", ";\n      border: 1px solid ", ";\n\n      ", " ", ":last-child ", " {\n        border: none;\n      }\n    "])), !square && px(4), palette2('neutral', 'l02'), RcTableBody, RcTableRow, RcTableCell));
};
var templateObject_1, templateObject_2;
